import { Badge, Box, Tooltip } from "@mui/material";
import React, { Component } from "react";
import TickIcon from "../resources/icons-check-circle-fill.svg";
import WarningIcon from "../resources/icons-warning-circle-fill.svg";

export default class ComplianceBadge extends Component<any> {
  static defaultProps = {
    size: 24,
    margin: "0 16px 16px 0",
  };

  renderCompliantBadge() {
    const { size }: any = this.props;

    return (
      <Box
        className="klayo_profilepic_badge klayo_profilepic_compliantbadge"
        sx={{
          width: size + "px",
          height: size + "px",
          "& svg": { width: size + "px", height: size + "px" },
        }}
      >
        <TickIcon style={{ width: size + "px", height: size + "px" }} />
      </Box>
    );
  }

  renderNonCompliantBadge() {
    const { size }: any = this.props;

    return (
      <Box
        className="klayo_profilepic_badge klayo_profilepic_noncompliantbadge"
        sx={{
          width: size + "px",
          height: size + "px",
          "& svg": { width: size + "px", height: size + "px" },
        }}
      >
        <WarningIcon style={{ width: size + "px", height: size + "px" }} />
      </Box>
    );
  }

  render() {
    const {
      isCompliant,
      children,
      anchorOrigin,
      size,
      margin,
      sx,
      showTooltip,
    }: any = this.props;

    return (
      <Badge
        badgeContent={
          showTooltip ? (
            isCompliant ? (
              <Tooltip title="Compliant" placement="top">
                {this.renderCompliantBadge()}
              </Tooltip>
            ) : (
              <Tooltip title="Non-compliant" placement="top">
                {this.renderNonCompliantBadge()}
              </Tooltip>
            )
          ) : isCompliant ? (
            this.renderCompliantBadge()
          ) : (
            this.renderNonCompliantBadge()
          )
        }
        anchorOrigin={anchorOrigin}
        sx={{ margin: margin, ...sx }}
      >
        {children}
      </Badge>
    );
  }
}
